var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tw-block tw-h-full tw-w-full tw-pl-4 tw-leading-10 tw-text-black md:tw-my-5 md:tw-pl-0 md:tw-leading-normal md:tw-text-inherit md:hover:tw-underline",attrs:{"href":_vm.link.url}},[_vm._v(_vm._s(_vm.link.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }